import React from 'react';
import MiniTable from 'Components/MiniTable';
import { Column } from 'react-table';
import styles from './index.css';

type Props = {
    data: SimulationPerformanceTableItem[];
    columns: Column<SimulationPerformanceTableItem>[];
    dataTestId: string;
    noDataMessage: string;
};

const RuleSimulationTable = ({ data, columns, dataTestId, noDataMessage }: Props) => {
    return (
        <MiniTable
            className={styles.tableContainer}
            dataTestId={dataTestId}
            data={data}
            columns={columns}
            noDataMessage={noDataMessage}
        />
    );
};

export default RuleSimulationTable;
